import payBills from './paybills';
import billsCategories from './billsCategories';

export default [payBills, billsCategories];
